import { lazy } from "react"
import { RouteProps } from "../features.types"

const FaqsController = lazy(() => import("./faqs-controller"))
const FaqsHome = lazy(() => import("./faqs"))
// define route constant
export const FAQS_ROUTE = "faqs"

//define routes
export const Faqs: RouteProps[] = [
  {
    path: `${FAQS_ROUTE}`,
    Component: FaqsController,
    children: [
      {
        index: true,
        Component: FaqsHome,
      },
    ],
  },
]
